<template>
  <section class="container" style="background-color: #000000">
    <full-page ref="fullpage" :options="options">
      <!-- Sección 1 -->
      <div class="section" data-anchor="pro1" id="section1" style="margin-bottom:15px;">
        <div class="fp-bg"></div>

        <span v-touch:swipe="swipeHandlerProyectos">
          <ul class="proyectos" :style="yLista" id="lista2">
            <li id="li-1" v-for="proyecto in proyectos" :key="proyecto.numero">
              <div
                class="titulo-proyecto"
                @click="selectProyecto(proyecto)"
                v-bind:style="[
                proyecto.numero == proyectoSeleccionado
                  ? { opacity: '1' }
                  : { opacity: '0.4' }
              ]"
              >
                <div
                  class="nProyecto"
                  v-bind:style="[
                  proyecto.numero == proyectoSeleccionado
                    ? {
                        'border-bottom': '2px solid white',
                        opacity: '1',
                        transform: 'translateX(0px)'
                      }
                    : {
                        'border-bottom': '0px solid white',
                        opacity: '0',
                        transform: 'translateX(-90px)'
                      }
                ]"
                >{{ proyecto.numeroString }}</div>
                {{ proyecto.titulo }}
              </div>

              <div
                class="descripcion"
                v-bind:style="[
                proyecto.numero == proyectoSeleccionado
                  ? { opacity: '1', transform: 'translateX(40vw)' }
                  : { opacity: '0', transform: 'translateX(30vw)' }
              ]"
              >
                <p style="color: white; font-size: 30px;">
                  <v-btn class="boton" @click="selectProyecto(proyecto)">Ver Proyecto</v-btn>
                  {{ proyecto.resumen }}
                </p>
                <p style="color: white; font-size: 20px;">
                  {{ proyecto.ejecutado }}
                </p>
                <v-row>
                  <v-col cols="7">
                <p v-if="proyectoSeleccionado == 2" class="textoAS">
                  <a
                    href="https://asinteriorista.com/"
                    target="_blank"
                    style="font-family: 'Source'; color: white !important; font-size: 25px;"
                  >Proyecto de Estudio AS Interiorista</a>
                </p>
                </v-col>
                <v-col cols="5">

                  <v-img
                    v-if="proyectoSeleccionado == 2"
                    :src="image_srclogoAS"
                    contain
                    href="https://asinteriorista.com/" 
                    target="_blank"
                    class="logo-as"
                  ></v-img>

                </v-col>
                </v-row>
                <p style="color: white; font-size: 20px; font-style: italic;">{{ proyecto.lugar }}</p>

                <p style="color: white; font-size: 20px; font-style: italic;">{{ proyecto.año }}</p>
                <br />
                <br />
              </div>
            </li>
          </ul>
        </span>

        <div class="nTotalProyectos">04</div>

        <div class="slide" id="slide1-1">
          <div class="fp-bg"></div>
        </div>

        <div class="slide" id="slide1-2">
          <div class="fp-bg"></div>
        </div>

        <div class="slide" id="slide1-3">
          <div class="fp-bg"></div>
        </div>

        <div class="slide" id="slide1-4">
          <div class="fp-bg"></div>
        </div>
      </div>
    </full-page>
  </section>
</template>

<script>
import store from "../store";

export default {
  data() {
    return {
      proyectos: [
        {
          numero: 1,
          numeroString: "01",
          isActive: true,
          route: "/apiadate",
          titulo: "Apiádate de mí",
          resumen: "Bar quitapena",
          lugar: "Santiago",
          año: "2019",
          programa:
            "Barra de Cerveza Craft con 14 lineas, Salon de mesas compartidas, terraza lounge y baños",
          colaboradores: [
            "@matiulloa_",
            "@iracundataller",
            "@thejoystudio",
            "@camilobdelpin"
          ],
          superficie: "60 m2",
          descripcion: [
            "Creamos este espacio con una arquitectura que reúne la nostalgia del bar de barrio chileno, el bolero y la psicodelia del joven chileno actual, todo en función de una gran barra de cerveza artesanal montón de líneas de cerveza craft con el fin de que la barra sea el centro articulador del espacio configurando un bar quitapena que acoge a todos quienes han sufrido un dolor en el corazón.",
            "Se plantea una fachada abierta hacia la calle integrando el espacio público, por lo que se restaura antiguos marcos de ventanas. A si mismo en el interior se mantienen las materialidades originales integrando un proyecto de iluminación y murales en las paredes.",
            "Se trabaja junto a ilustradores, diseñadores gráfico y fotógrafos para construir la imagen: logo, carta, instagram. Teniendo como resultado un proyecto integral y completo bajo un mismo concepto."
          ]
        },
        {
          numero: 2,
          numeroString: "02",
          isActive: false,
          route: "/sushi",
          titulo: "True Sushi",
          resumen: "Restaurant comida fusión japonesa – hawaiana",
          lugar: "Madrid",
          año: "2019",
          programa:
            "Barra con pesca milagrosa, cocina caliente y fría en barra, baños",
          colaboradores: ["@manilawallart"],
          superficie: "26 m2",
          descripcion: [
            "Creamos este espacio con una arquitectura que reúne la cultura japonesa y hawaiana, creando una fusión de éstas. Se proyectó un mural en frente de la barra que le diere carácter al espacio. Una gran pintura hecha a mano que evoca la gran ola de KANAGAWA, por otra parte, en el techo se instalaron lámparas de grandes peces de origami. Otro sello distintivo del proyecto, es la barra en donde se ubica una pequeña laguna en donde hay patitos de goma que pueden pescarse con una caña mientras te instalas a comer."
          ]
        },
        {
          numero: 3,
          numeroString: "03",
          isActive: false,
          route: "/raak",
          titulo: "Gimnasio RAAK",
          resumen: "Interiorismo e instalación",
          lugar: "Santiago",
          año: "2020",
          ejecutado: "Proyecto no ejectuado - Solo propuesta de diseño",
          programa:
            "Interiorismo de espacios de spa, baños y camarines. Proyecto de iluminación y propuesta de instalación a escala humana",
          colaboradores: ["@estudioamani", "@iracundataller"],
          superficie: "26 m2",
          descripcion: [
            "Creamos este espacio con una arquitectura que reúne la cultura japonesa y hawaiana, creando una fusión de éstas. Se proyectó un mural en frente de la barra que le diere carácter al espacio. Una gran pintura hecha a mano que evoca la gran ola de KANAGAWA, por otra parte, en el techo se instalaron lámparas de grandes peces de origami. Otro sello distintivo del proyecto, es la barra en donde se ubica una pequeña laguna en donde hay patitos de goma que pueden pescarse con una caña mientras te instalas a comer."
          ]
        },
        {
          numero: 4,
          numeroString: "04",
          isActive: false,
          route: "/d2b",
          titulo: "Oficina D2B",
          resumen: "Remodelación planta libre oficinas D2B",
          lugar: "Santiago",
          año: "2020",
          ejecutado: "Proyecto no ejectuado - Solo propuesta de diseño",
          programa:
            "25 puestos de trabajo, pecera, sala de reuniones, muebles de guardado, sector de juegos, acceso",
          colaboradores: ["@matiulloa_"],
          superficie: "138 m2 ",
          descripcion: [
            "Propuesta que se centró en generar areas lúdicas, funcionales y amigables generando espacios que aportan al bienestar de las personas y nuevas formas de trabajo que se desarrollan en una planta libre, por lo que se propone un diseño oficina que facilite las relaciones de manera más transversal y dinámica, entendiendo las nuevas relaciones laborales. ",
            "En este sentido la idea fue diseñar puestos de trabajo movibles siendo oportunos para un trabajo individual como colectivo utilizando colores limpios y vivaces con mobiliarios más llamativos. Para generar un impacto visual al entrar a las oficinas se propone un mural pintado a mano en el acceso con un área de espera que también puede ser usada para trabajar.  "
          ]
        }
      ],
      posicionLista: -25,
      proyectoSeleccionado: 1,
      rutaProyectoSeleccionado: "",
      image_srcproy: require("../assets/Menu-proyectos.jpg"),
      image_srclogoAS: require("../assets/LOGO_AS.png"),
      options: {
        licenseKey: "265864DA-1DE54052-9BEBB977-EF50CFB8",
        parallax: true,
        parallaxKey: [
          "Y29sZWN0aXZvYWxxdWltaWEuY2xfYmxNY0dGeVlXeHNZWGc9OTJR",
          "Y29sZWN0aXZvLWFscXVpbWlhLndlYi5hcHBfdjhXY0dGeVlXeHNZWGc9QVEw",
          "Y29sZWN0aXZvLWFscXVpbWlhLndlYi5hcHBfNjI0Y0dGeVlXeHNZWGc9WVlP"
        ],
        // parallaxKey: '7CD7B03B-68104BF5-88FFE8B4-2585F4CC',
        // activation-key for domain colectivoalquimia.cl: Y29sZWN0aXZvYWxxdWltaWEuY2xfcmg0Y0dGeVlXeHNZWGc9bHhi
        autoScrolling: true,
        fitToSection: true,
        slidesNavigation: false,
        controlArrows: false,
        verticalCentered: true,
        bigSectionsDestination: "top",
        scrollingSpeed: "700",
        parallaxOptions: {
          type: "cover",
          percentage: 99,
          property: "translate"
        },
        onLeave: function(origin, destination, direction) {
          if (origin.index == 0) {
            store.commit("esconder");
          } else if (origin.index == 1 && direction == "up") {
            store.commit("mostrar");
          }
        }
      }
    };
  },
  metaInfo: {
    title: "Colectivo Alquimia",
    titleTemplate: "%s | Proyectos"
  },
  computed: {
    yLista() {
      return `transform: translateY(${this.posicionLista}%)`;
    }
  },
  mounted() {
    window.addEventListener("click", this.onClick, true);
    window.addEventListener("scroll", this.onScroll, true);
    window.addEventListener("wheel", this.onWheel, true);
    this.$refs.fullpage.api.moveTo(0);
    store.commit("mostrar");
    //setTimeout(function() {store.commit("esconder");}, 2000);
  },
  destroyed() {
    window.removeEventListener("click", this.onClick, true);
    window.removeEventListener("scroll", this.onScroll, true);
    window.removeEventListener("wheel", this.onWheel, true);
  },
  methods: {
    isOnTop() {
      if (this.$refs.fullpage.api.getActiveSection().anchor == "pro1") {
        return true;
      } else {
        return false;
      }
    },
    getSection() {
      return this.$refs.fullpage.api.getActiveSection().anchor;
    },
    getSectionIndex() {
      return this.$refs.fullpage.api.getActiveSection().index;
    },
    async selectProyecto(proyecto) {
      let ruta = proyecto.route;
      if (this.proyectoSeleccionado == proyecto.numero) {
        await this.$router
          .push({
            path: ruta
          })
          .catch(err => {
            throw new Error(`Router loco: ${err}.`);
          });
      } else {
        store.commit("esconder");
        this.proyectoSeleccionado = proyecto.numero;
        this.rutaProyectoSeleccionado = proyecto.ruta;
        console.log("ruta: " + this.rutaProyectoSeleccionado);
        var n = this.proyectoSeleccionado - 1;
        this.posicionLista = this.proyectoSeleccionado * -25;
        this.$refs.fullpage.api.moveTo(1, n);
      }
    },
    onClick() {
      store.commit("esconder");
      /*
      if (this.$refs.routerViewRef.getSection() == "pro1") {
        if(store.state.headerIsVisible){
          this.isOnTop = false;
          store.commit('esconder');
        }
      }
      */
    },
    swipeHandlerProyectos(direction) {
      if (direction == "top") {
        if (!store.state.headerIsVisible) {
          if (this.proyectoSeleccionado == 1) {
            this.$router
              .push({
                path: "/apiadate"
              })
              .catch(err => {
                throw new Error(`Router loco: ${err}.`);
              });
          } else if (this.proyectoSeleccionado == 2) {
            this.$router
              .push({
                path: "/sushi"
              })
              .catch(err => {
                throw new Error(`Router loco: ${err}.`);
              });
          } else if (this.proyectoSeleccionado == 3) {
            this.$router
              .push({
                path: "/raak"
              })
              .catch(err => {
                throw new Error(`Router loco: ${err}.`);
              });
          } else if (this.proyectoSeleccionado == 4) {
            this.$router
              .push({
                path: "/d2b"
              })
              .catch(err => {
                throw new Error(`Router loco: ${err}.`);
              });
          }
        }
        /*
        let n = this.proyectoSeleccionado - 1;
        if (this.proyectoSeleccionado == 2) {
          this.posicionLista = this.proyectoSeleccionado * -25;
          this.$refs.fullpage.api.moveTo(1, n);
          this.proyectoSeleccionado = 1;
        } else if (this.proyectoSeleccionado == 3) {
          this.posicionLista = this.proyectoSeleccionado * -25;
          this.$refs.fullpage.api.moveTo(1, n);
          this.proyectoSeleccionado = 2;
        } else if (this.proyectoSeleccionado == 4) {
          this.posicionLista = this.proyectoSeleccionado * -25;
          this.$refs.fullpage.api.moveTo(1, n);
          this.proyectoSeleccionado = 3;
        }
      } else {
        let n = this.proyectoSeleccionado - 1;
        if (this.proyectoSeleccionado == 1) {
          this.posicionLista = this.proyectoSeleccionado * -25;
          this.$refs.fullpage.api.moveTo(1, n);
          this.proyectoSeleccionado = 2;
        } else if (this.proyectoSeleccionado == 2) {
          this.posicionLista = this.proyectoSeleccionado * -25;
          this.$refs.fullpage.api.moveTo(1, n);
          this.proyectoSeleccionado = 3;
        } else if (this.proyectoSeleccionado == 3) {
          this.posicionLista = this.proyectoSeleccionado * -25;
          this.$refs.fullpage.api.moveTo(1, n);
          this.proyectoSeleccionado = 4;
        }
      }
      */
      }
    }
  }
};
</script>

<style>
.fp-bg {
  background-size: cover;
  transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden; /* Chrome, Safari, Opera */
  backface-visibility: hidden;
}
.container {
  padding: 0px;
  margin: 0px;
  transition: all 0.45s ease-in-out;
  transition: all 0.45s cubic-bezier(0.55, 0, 0.1, 1);
}
.slide {
  height: 100vh;
}
#lista2 {
  list-style-type: none;
}
.section {
  background-color: rgba(0, 0, 0, 0);
  min-width: 100vw;
  min-height: 100vh;
  z-index: -1;
}
#slide1-1 .fp-bg {
  background-image: url("../assets/1.jpg");
  background-size: cover;
  background-position: center 80%;
}
#slide1-2 .fp-bg {
  background-image: url("../assets/2.jpg");
  background-size: cover;
  background-position: left center 80%;
}
#slide1-3 .fp-bg {
  background-image: url("../assets/3.jpg");
  background-size: cover;
  background-position: center 80%;
}
#slide1-4 .fp-bg {
  background-image: url("../assets/4.jpg");
  background-size: cover;
  background-position: center 80%;
}
.textoAS {
  position: relative;
  transition-duration: 625ms;
  transition: opacity 0.5s, transform 0.5s;
  font-size: 25px;
  color: white;
}
.textoAS:hover {
  transition-duration: 625ms;
  transition: opacity 0.5s, transform 0.5s;
  font-size: 25px;
  color: white;
  opacity: 0.7;
}
.logo-as {
  width: 80px;
}
@media (min-width: 960px) {
  .proyectos {
    position: fixed;
    top: 55vh;
    width: 40vw;
    left: 15vw;
    z-index: 9999;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
  }
  #li-1 {
    height: 6vw;
    width: 10vw;
  }
  .nProyecto {
    position: relative;
    bottom: 6vh;
    font-size: calc(20.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 120px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    transition: opacity 0.5s, transform 0.5s;
  }
  .nTotalProyectos {
    position: fixed;
    bottom: 5vh;
    left: 15vw;
    font-size: calc(20.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 120px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    color: white;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99;
    opacity: 0.5;
  }
  .boton {
    font-size: calc(3.5px + 0.8125vw);
    padding: 10px;
    position: fixed !important;
    font-family: "Source";
    top: 25vh;
    right: 1vw;
    z-index: 999999;
    cursor: pointer;
    -webkit-box-shadow: -1px 10px 5px -6px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: -1px 10px 5px -6px rgba(0, 0, 0, 0.75);
    box-shadow: -1px 10px 5px -6px rgba(0, 0, 0, 0.75);
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99999;
  }
  .titulo-proyecto {
    position: absolute;
    height: 6vw;
    padding: 0em;
    white-space: nowrap;
    font-size: calc(10.5px + 1.98125vw);
    font-family: "Source-bold";
    color: white;
    text-decoration: none;
    text-shadow: 0px 0px #000000;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99999;
    cursor: pointer;
  }
  .descripcion {
    position: absolute;
    font-size: calc(4.5px + 1.28125vw);
    color: white;
    background-color: rgba(0, 0, 0, 0.7);
    font-family: "Source";
    padding: 1vw;
    min-width: 40vw;
    transition-duration: 625ms;
    text-shadow: 0px 0px #000000;
    border-radius: 5px 5px 5px 5px;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99;
  }
  .subdescripcion {
    position: absolute;
    font-size: calc(4.5px + 0.98125vw);
    color: white;
    height: 3vh;
    top: 10vh;
    margin-bottom: 5vh;
    font-family: "Source";
    transition-duration: 625ms;
    text-shadow: 0px 0px #000000;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99;
  }
  .titulo-proyecto:hover {
    opacity: 0.8 !important;
  }
  .subtitulo-proyecto {
    font-family: "Source";
    font-size: calc(10.5px + 1.78125vw);
  }
  .texto-card {
    font-family: "Source";
    font-size: 20px;
    font-weight: 400;
    padding-top: 20px;
    color: #ffffff;
    line-height: 1;
  }
}
@media (max-width: 960px) {
  .proyectos {
    position: fixed;
    top: 60vh;
    width: 50vw;
    left: 20vw;
    z-index: 99;
    white-space: nowrap;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
  }
  #li-1 {
    white-space: nowrap;
  }
  .descripcion {
    display: none;
    position: absolute;
    font-size: calc(4.5px + 1.28125vw);
    color: white;
    bottom: 40vh;
    font-family: "Source";
    transition-duration: 625ms;
    text-shadow: 0px 0px #000000;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99;
  }
  .nProyecto {
    position: relative;
    bottom: 4vh;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 60px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    transition: opacity 0.5s, transform 0.5s;
  }
  .nTotalProyectos {
    position: fixed;
    bottom: 12vh;
    left: 20vw;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 120px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    color: white;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99;
    opacity: 0.5;
  }
  .titulo-proyecto {
    position: relative;
    padding: 0em;
    white-space: nowrap;
    font-size: calc(14.5px + 1.98125vw);
    font-family: "Source-bold";
    color: white;
    z-index: 99999;
    text-decoration: none;
    text-shadow: 0px 0px #000000;
    transform: translateZ(0px) translateY(-0.5em) translateY(0vh)
      translateY(0em);
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
    cursor: pointer;
  }
  .titulo-proyecto:hover {
    opacity: 0.8 !important;
  }
  .subtitulo-proyecto {
    font-family: "Source";
    font-size: calc(10.5px + 1.78125vw);
  }
  .texto-card {
    font-family: "Source";
    font-size: 20px;
    font-weight: 400;
    padding-top: 20px;
    color: #ffffff;
    line-height: 1;
  }
}
</style>
